import React from 'react';

const GridDataContext = React.createContext(null);

export default GridDataContext;
